/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type WordOrderWidget_exercise = {
    readonly content: {
        readonly correctAnswers: ReadonlyArray<string>;
        readonly scrambledParts: ReadonlyArray<string>;
    };
    readonly " $refType": "WordOrderWidget_exercise";
};
export type WordOrderWidget_exercise$data = WordOrderWidget_exercise;
export type WordOrderWidget_exercise$key = {
    readonly " $data"?: WordOrderWidget_exercise$data;
    readonly " $fragmentRefs": FragmentRefs<"WordOrderWidget_exercise">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "WordOrderWidget_exercise",
  "type": "WordOrderExercise",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "content",
      "storageKey": null,
      "args": null,
      "concreteType": "WordOrderExerciseContent",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "correctAnswers",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "scrambledParts",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
(node as any).hash = '98d8b1859576419300998e0cc32250d1';
export default node;
